import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Swal from 'sweetalert2';
import gql from 'graphql-tag';
import Loader from '../../components/CustomLoader';
import client from '../../utils/apolloClient';
import { getUser } from '../../data-services/queries';
import { listAssignedFcpsForCmdi } from './ettcSubmissionApi';

const queryString = require('query-string');

/**
 * Assigned FCP list for CMDI or AMMD (role from login).
 * AMMD requires ?cmdiSfid= (selected CMDI); without it redirects to CMDI list.
 * prop roleHint optional; otherwise uses logged-in user.role
 */
class ListETTCFcps extends Component {
    state = {
        loading: true,
        userData: null,
        fcps: [],
        role: null,
        search: '',
        cmdiSfid: null,
        cmdiName: '',
        backPath: null,
    };

    async componentDidMount() {
        const params = queryString.parse(
            (this.props.location && this.props.location.search) ||
                window.location.search ||
                ''
        );
        const cmdiSfid = params.cmdiSfid || null;
        const cmdiName = params.cmdiName || '';
        const backPath = params.back || null;

        const { data } = await client.query({ query: gql(getUser) });
        const userData = data && data.user;
        const role = this.props.roleHint || (userData && userData.role);
        this.setState({ userData, role, cmdiSfid, cmdiName, backPath });

        if (!userData || !userData.sfid || (role !== 'CMDI' && role !== 'AMMD')) {
            this.setState({ loading: false, role });
            return;
        }

        if (role === 'AMMD' && !cmdiSfid) {
            this.props.history.replace('/ettc-ammd-cmdis');
            return;
        }

        try {
            const loadSfid = role === 'AMMD' ? cmdiSfid : userData.sfid;
            const fcps = (await listAssignedFcpsForCmdi(loadSfid)).filter(
                (fcp) => Number(fcp.total_submissions) > 0
            );
            this.setState({ fcps, loading: false, role });
        } catch (err) {
            this.setState({ loading: false, role });
            Swal.fire({
                icon: 'error',
                title: 'Load failed',
                text: 'Could not load assigned FCPs.',
            });
        }
    }

    gotoBack = () => {
        const { role, backPath } = this.state;
        if (role === 'AMMD') {
            this.props.history.push(backPath || '/ettc-ammd-cmdis');
            return;
        }
        this.props.history.push('/homeCMDI');
    };

    fcpListReturnPath = () => {
        const { role, cmdiSfid, cmdiName, backPath } = this.state;
        if (role === 'AMMD' && cmdiSfid) {
            return `/ettc-ammd-fcps?cmdiSfid=${encodeURIComponent(
                cmdiSfid
            )}&cmdiName=${encodeURIComponent(cmdiName || '')}&back=${encodeURIComponent(
                backPath || '/ettc-ammd-cmdis'
            )}`;
        }
        return '/ettc-cmdi-fcps';
    };

    openFcp = (fcp) => {
        const listPath = this.fcpListReturnPath();
        this.props.history.push({
            pathname: '/ettc-fcp-submissions',
            search: `?fcpSfid=${encodeURIComponent(fcp.sfid)}&fcpName=${encodeURIComponent(
                fcp.name || ''
            )}&back=${encodeURIComponent(listPath)}`,
        });
    };

    render() {
        const { loading, fcps, role, search, cmdiName } = this.state;
        const term = (search || '').trim().toLowerCase();
        const visible = term
            ? fcps.filter((fcp) => (fcp.name || '').toLowerCase().includes(term))
            : fcps;

        const title =
            role === 'AMMD'
                ? cmdiName
                    ? `${cmdiName} — ETTC FCP List`
                    : 'AMMD — ETTC FCP List'
                : 'CMDI — ETTC FCP List';

        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.gotoBack}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit">
                            {title}
                        </Typography>
                    </Toolbar>
                </AppBar>

                {loading ? (
                    <Grid container alignItems="center" justify="center" style={{ marginTop: 24 }}>
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <div>
                        <div style={{ padding: 12 }}>
                            <TextField
                                fullWidth
                                placeholder="Search FCP"
                                value={search}
                                onChange={(e) => this.setState({ search: e.target.value })}
                                margin="none"
                            />
                        </div>
                        <Paper square>
                            {!visible.length ? (
                                <Typography style={{ padding: 16 }}>
                                    {term
                                        ? 'No matching FCPs found.'
                                        : 'No FCPs with ETTC submissions.'}
                                </Typography>
                            ) : (
                                visible.map((fcp) => (
                                    <div key={fcp.sfid || fcp.id}>
                                        <List
                                            onClick={() => this.openFcp(fcp)}
                                            style={{ cursor: 'pointer', padding: 12 }}
                                        >
                                            <Grid container spacing={8} alignItems="center">
                                                <Grid item xs={7}>
                                                    <Typography variant="body2">
                                                        {fcp.name}
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        Total: {fcp.total_submissions || 0}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography align="right" variant="caption">
                                                        Pending: {fcp.pending_count || 0}
                                                    </Typography>
                                                    <Typography align="right" variant="caption">
                                                        Approved: {fcp.approved_count || 0}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </List>
                                        <Divider />
                                    </div>
                                ))
                            )}
                        </Paper>
                    </div>
                )}
            </div>
        );
    }
}

export const ListETTCFcpsCMDI = (props) => <ListETTCFcps {...props} roleHint="CMDI" />;
export const ListETTCFcpsAMMD = (props) => <ListETTCFcps {...props} roleHint="AMMD" />;

export default ListETTCFcps;
